import { CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { fDate } from '../../../../utils/formatTime'
import StyledTableContainer from '../../../../newTestPrep/newComponent/TableContainer'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

function GradlynkServicesTable({ enquiryId}) {
    const [loading, setLoading] = useState(false)
    const [gradlynkService, setGradlynkService] = useState([])

    useEffect(() => {
        setLoading(true)
        fetch(`${API_ENDPOINT}route2.0/fetchgradlynkservice/${enquiryId}`)
        .then(response => response.json())
        .then(data => {
          data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setGradlynkService(data);
          setLoading(false)
        })
        .catch(error => {
          console.error('Error fetching payments items:', error);
          setLoading(false)
        });
    }, [enquiryId]);

  return (
    <>
    {loading ? (
        <Grid container justifyContent="center" alignItems="center">
          <CircularProgress />
        </Grid>
      ) : (
    <>
      {gradlynkService.length === 0 ? (
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">No gradlynk service history available</Typography>
        </Grid>
      ) : (
       
          <StyledTableContainer
         
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    
                  >
                    Service
                  </TableCell>
                  <TableCell
                    
                  >
                    Sub Service
                  </TableCell>
                  <TableCell
                  
                  >
                    Country Of Interest
                  </TableCell>
                  <TableCell
                  
                  >
                    Gradlynk Branch
                  </TableCell>
                  <TableCell
                  
                  >
                    Note
                  </TableCell>
                  <TableCell
                    
                  >
                    Date
                  </TableCell>
                  <TableCell
                   
                  >
                    Created By
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gradlynkService.map((row, index) => (
                  <TableRow
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f0f0f0" : "inherit",
                      width: "6%",
                    }}
                  >
                    <TableCell>{row?.service_id}</TableCell>
                    <TableCell>
                    {row?.sub_service_id}
                    </TableCell>
                    <TableCell>{row?.first_country_of_interest}</TableCell>
                    <TableCell>
                      {row?.nearest_branch}
                    </TableCell>
                    <TableCell>
                      {row?.notes}
                    </TableCell>
                    <TableCell>{fDate(row?.createdAt)}</TableCell>
                    <TableCell>{row?.created_by?.first_name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
       
      )}
       </>
      )}
      </>
  )
}

export default GradlynkServicesTable